import { h } from 'preact'
import PNFO from 'jlinc-shared/PNFO'

import classNames from 'lib/classNames'
import {
  useMyOrganizations,
  usePublicOrganizations,
} from 'lib/membershipAppStateHooks'

import MyOrganizationsList from 'components/MyOrganizationsList'

export default function PublicOrganizationsList({ className, textFilter, ...props }){
  const {
    publicOrganizations,
    publicOrganizationsLoading,
    publicOrganizationsLoadingError,
  } = usePublicOrganizations('PublicOrganizationsList')

  const {
    myOrganizations = [],
  } = useMyOrganizations('PublicOrganizationsList')

  const organizationsLoading = (
    !publicOrganizations ||
    publicOrganizationsLoading
  )

  let organizations = organizationsLoading
    ? undefined
    : [...(myOrganizations || []), ...(publicOrganizations || [])]

  // Remove duplicates based on apikey
  organizations = organizations?.filter((item, index, array) => {
    if (!item?.apikey) return false
    return array.findIndex(obj => obj?.apikey === item.apikey) === index
  })

  return <MyOrganizationsList {...{
    ...props,
    error: publicOrganizationsLoadingError,
    className: classNames('PublicOrganizationsList', {className}),
    organizationsLoading,
    organizations,
    textFilter,
    onEmpty: `There are no public ${PNFO.plural}`,
  }}/>
}
